import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesClientes() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: [
      { label: "Clientes", icon: "fas fa-user-tie", color: "#2563eb", href: "/Clientes", enabled: !!(user.menu_facturas && user.menu_clientes) },
      { label: "Estado de Cuenta", icon: "fas fa-file-invoice", color: "#2563eb", href: "/EdoCtaClientes", enabled: !!(user.menu_facturas && user.facturas_edo_cta) },
      { label: "Cobranza", icon: "far fa-money-bill-alt", color: "#2563eb", href: "/ListadoCobranza", enabled: !!(user.menu_facturas && user.facturas_edo_cta) },
      { label: "Notas", icon: "fas fa-file-invoice-dollar", color: "#2563eb", href: "/DetalleNotas", enabled: !!(user.menu_facturas && user.facturas_cargos) },
      { label: "Abonos", icon: "fas fa-donate", color: "#2563eb", href: "/AbonosClientes", enabled: !!(user.menu_facturas && user.facturas_abonos) },
      { label: "Zonas", icon: "fas fa-map-marked-alt", color: "#2563eb", href: "/Zonas", enabled: !!(user.menu_facturas) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Clientes"
      descripcion="Clientes, cobranza y estados de cuenta"
      icono="fas fa-user-tie"
      color="#2563eb"
      secciones={secciones}
    />
  );
}

export default BotonesClientes;
